import { SET_HEADER, SET_SIDEMENU } from './types';

export default {
    [SET_HEADER](state: { header: any; }, headerData: any) {
        // tslint:disable-next-line:no-console
        state.header = headerData;
    },

    [SET_SIDEMENU](state: { sideMenu: any; }, sideMenu: any) {
        state.sideMenu = sideMenu;
    },
};
